import React from 'react';
import { useForm } from 'react-hook-form';
import CrudEdit from '~/components/CrudEdit';
import IOrganization from '../interfaces/IOrganization';


export default function Edit() {     
  const {register, handleSubmit, control, setValue:setFormValue, getValues} = useForm<IOrganization>();
  const fields = [
      { name: 'id', type: 'hidden'},
      { name: 'name', type: 'string'},
      { name: 'acronym', type: 'string'},
      { name: 'notes', type: 'string'},
      { name: 'is_public', type: 'boolean'},
  ];
  
    return(
      <CrudEdit 
        model={'organization'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        setFormValue={setFormValue}
        messageSuccess={'Organization successfully updated!'}  
        title={'Edit organization'}
        getValues={getValues} 
      />
    )
}
